// extracted by mini-css-extract-plugin
module.exports = {"groupWrap":"dangerzone_groupWrap__28z9p","dangerGroup":"dangerzone_dangerGroup__Y0KZz"};